// Keep the deployed domains' existing identities. Local development previews
// the Setflows identity used by the native app.
export const IS_SETFLOWS =
  import.meta.env.DEV ||
  (typeof window !== "undefined" &&
    window.location.hostname.replace(/^www\./, "") === "setflows.com");

export const BRAND_NAME = IS_SETFLOWS ? "Setflows" : "Worshipr";
